import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    //   {
    //     path: '/',
    //     name: 'Home',
    //     component: Home
    //   },
    {
        path: '/research-integrity',
        name: 'homepage',
        component: () => import('../views/research_integrity/research-integrity/homepage.vue'),
        meta: {
            title: '科研诚信',
            icon: 'dashboard'
        },
        children:[
            // 失信单位
            {
                path: 'reporting',
                name: 'reporting',
                component: () => import('../views/research_integrity/research-integrity/reporting.vue'),
                meta: {
                title: '举报须知',
                },
            },
            // 失信个人
            {
                path: 'personreporting',
                name: 'reporting',
                component: () => import('../views/research_integrity/research-integrity/unitreporting.vue'),
                meta: {
                title: '举报须知',
                },
            },
            {
                path: 'tabulation',
                name: 'tabulation',
                component: () => import('../views/research_integrity/research-integrity/tabulation.vue'),
                meta: {
                title: '举报列表',
                },
            },
            {
                path: 'realname',
                name: 'realname',
                component: () => import('../views/research_integrity/research-integrity/realname.vue'),
                meta: {
                title: '实名举报',
                },
            },
            {
                path: 'anonymous',
                name: 'anonymous',
                component: () => import('../views/research_integrity/research-integrity/anonymous.vue'),
                meta: {
                title: '匿名举报',
                },
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
